export default {
      id: "sentiment-client-negative-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#sentiment-client-negative-usage",
      toString: function () {
        return this.url;
      }
    }